@import '../../shared';

.react-numeric-input {
  margin-bottom: 1.5rem;
  display: flex;

  > b {
    display: block;
    width: 4rem;
    height: 4rem;
    border-radius: 50%;
    background-color: $blue;
    vertical-align: middle;
    justify-content: center;
    flex: 0 auto;
    order: 3;
    position: relative;
    cursor: pointer;

    &:hover {
      background-color: $blue-section-heading;
    }

    &:active {
      background-color: $blue-text;
    }

    &:focus {
      box-shadow: 0 0 0.8rem 0 $blue;
    }
  }

  > b > i {
    display: block;
    width: 1.6rem;
    height: 0.4rem;
    background: #fff;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    + i {
      width: 0.4rem;
      height: 1.6rem;
    }
  }
}

.form-incremental-stepper {
  @include form-component;
  height: 4rem;
  font-size: inherit;
  border-radius: $border-radius-small;
  text-align: center;
  line-height: 4rem;
  margin-right: 1.5rem;
  margin-left: 1.5rem;
  width: auto;
  // Use long-hand flex property for IE11. See
  // https://github.com/philipwalton/flexbugs#8-flex-basis-doesnt-support-calc
  flex: 1 1 auto;
  order: 2;

  &:focus {
    outline: none;
    border-color: $blue;
  }

  &:disabled {
    @include form-component-disabled;
    font-style: italic;
  }
}

.react-numeric-input > b:last-child {
  order: 1;
}

.form-incremental-stepper:disabled ~ b {
  background-color: $border-color;
  cursor: default;
}
